import { push } from 'connected-react-router'
import {takeEvery, select, put} from 'redux-saga/effects'

import { getActivitiesHistory, activityActions, sendYesterdayActivity } from '../actions'
import { getIdentityActivitiesHistoryPage, getIdentityActivitiesHistoryLimit } from '../selectors'
import { queryParams } from 'store/entities/router/selectors'

export function* progressChangeHandler() {
  const query = yield select(queryParams)
  if (query?.actionSource === 'sms') {
    yield put(push('/dashboard'))
  }
  const page = yield select(getIdentityActivitiesHistoryPage)
  const limit = yield select(getIdentityActivitiesHistoryLimit)
  yield getActivitiesHistory.call({ page, limit })
}

export default function* fetchHistoryOnProgressUpdates() {
  yield takeEvery(
    [
      activityActions.commit.success.toString(),
      activityActions.did.success.toString(),
      activityActions.didnot.success.toString(),
      activityActions.complete.success.toString(),
      sendYesterdayActivity.success.toString(),
    ],
    progressChangeHandler
  )
}
